export default __webpack_public_path__ + "static/media/amertrad4.22ddf495.png";